import { render, staticRenderFns } from "./checkout3.vue?vue&type=template&id=0d346eff&scoped=true&"
import script from "./checkout3.vue?vue&type=script&lang=js&"
export * from "./checkout3.vue?vue&type=script&lang=js&"
import style0 from "./checkout3.vue?vue&type=style&index=0&id=0d346eff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d346eff",
  null
  
)

export default component.exports